<template>
  <CDropdown>
    <CDropdownToggle
      placement="bottom-end"
      class="py-0 text-end"
      :caret="false"
    >
      <strong style="font-weight: bold; padding-right: 8px; color: white">
        Welcome, {{ operatorName }}
      </strong>
      <i class="fa fa-user fa-xl" style="color: white" aria-hidden="true"></i>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownItem
        @click="this.$router.push({ name: 'ChangePIN' })"
        style="cursor: pointer"
      >
        <i class="fa fa-lock" aria-hidden="true"></i> Change PIN
      </CDropdownItem>
      <CDropdownItem @click="logout()" style="cursor: pointer">
        <i class="fa fa-sign-out" aria-hidden="true"></i>
        Logout
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
export default {
  name: 'AppHeaderDropdownAccnt',
  data() {
    return {
      operatorName: ''
    }
  },

  methods: {
    logout() {
      this.$url
        .delete('/operator/authentication', {
          headers: {
            'X-MOCO-MPS-TOKEN': sessionStorage.getItem('token')
          }
        })
        .then(() => {
          this.$router.replace({ name: 'Login' })
        })
        .catch((error) => {
          this.$router.replace({ name: 'Login' })
        })
    },
    changePassword() {
      this.$router.push({ name: 'ChangePassword' })
    }
  },
  created() {
    this.operatorName = sessionStorage.getItem('operatorName')
  }
}
</script>
